import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import React, { memo, useEffect, useRef, useState } from 'react'

import Loading from 'components/loading'
import { useSession } from 'helpers/checkSession'
import {
  CANCEL_JOB_BY_ID,
  CANCEL_RELATED_JOBS_BY_PG_NUMBER,
  GET_ALL_GA_JOB,
  GET_CONFIGURATION_BY_TYPE,
  TRIGGER_JOB_BY_ID,
  UPDATE_CONFIGURATION_BY_ID,
} from 'queries/adminPortal'
import { tableHeaderJobData } from './headers'
// import UserListDialog from './UserListDialog'
import IconApprove from 'assets/images/icon-approve.svg'
import IconDot from 'assets/images/icon-dot.svg'
import IconInformation from 'assets/images/icon-information.svg'
import { CODE_TIMEOUT } from 'constants/statusCode'
import SearchInput from 'pages/principal-account-management/components/searchInput'
import Moment from 'react-moment'
interface Props {
  setIsRefetchList: (refetchUser: boolean) => void
  isRefetchList: boolean
}

import { isAxiosError } from 'axios'
import classNames from 'classnames'
import ButtonBase from 'components/partials/button'
import DropdownBase from 'components/partials/dropDown'
import SingleRowActionBase from 'components/partials/singleRowActionBase'
import CheckBoxBase from 'components/partials/toggleBase'
import TotalNumberInTable from 'components/partials/totalNumberInTable'
import { notify } from 'components/toastify'
import { EMAIL_JOB_STATUS } from 'constants/common'
import { MESSAGES, STATUS } from 'constants/messages'
import moment from 'moment'
import axiosInstance from 'network/axiosClient'
import DialogBasic from 'pages/developer-portal/dialog/dialogBasic'
import DateFilterPicker from 'pages/developer-portal/table/activities-log/component/dateFilterPicker'
import InfiniteScroll from 'react-infinite-scroll-component'
import ReactTooltip from 'react-tooltip'
import { ActionJobItem, IJobItem, IPageInfo, Variables } from '../../interface'
import DetailItemDialog from './components/detail-item-dialog'

const JobTable: React.FC<Props> = ({ setIsRefetchList, isRefetchList }) => {
  const DEFAULT_PAGINATION = {
    LIMIT: 10,
    PAGE: 1,
  }
  const prevSearchObjectRef = useRef({})
  const menuRef = useRef<HTMLDivElement>(null)
  const subjectFilterRef = useRef<HTMLDivElement>(null)
  const subjectCheckboxRef = useRef<HTMLDivElement>(null)
  const [disableDownloadBtn, setDisableDownloadBtn] = useState<boolean>(false)
  const [isTableGaScroll, setIsTableGaScroll] = useState<boolean>(false)
  const [isFocusSearchEmailText, setIsFocusEmailText] = useState<boolean>(false)
  const [isFocusApplicationNumber, setIsFocusApplicationNumber] = useState<boolean>(false)
  const [searchObject, setSearchObject] = useState<Variables>({
    limit: DEFAULT_PAGINATION.LIMIT,
    page: DEFAULT_PAGINATION.PAGE,
    searchValue: '',
    applicationNumber: '',
  })
  const [minDateFilter, setMinDateFilter] = useState<Date>()
  const [maxDateFilter, setMaxDateFilter] = useState<Date>()
  const [isOpenModalCancelSingleJob, setIsOpenModalCancelSingleJob] = useState<boolean>(false)
  const [isOpenModalCancelRelatedJobs, setIsOpenModalCancelRelatedJobs] = useState<boolean>(false)
  const [isOpenModalTriggerJob, setIsOpenModalTriggerJob] = useState<boolean>(false)
  const [isOpenModalViewDetailJob, setIsOpenModalViewDetailJob] = useState<boolean>(false)
  const [currentJobItemSelected, setCurrentJobItemSelected] = useState<any>()
  const [listGAJobData, setListGAJobData] = useState<IJobItem[]>([])
  const [pageInfoGAJob, setPageInfoGAJob] = useState<IPageInfo>({
    currentPage: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    itemsPerPage: DEFAULT_PAGINATION.LIMIT,
    totalItems: 0,
    totalPages: 0,
  })
  const [showAction, setShowAction] = useState<ActionJobItem>({
    jobId: null,
    isShowAction: false,
  })
  const [serviceConfiguration, setServiceConfiguration] = useState({
    value: '',
    key: '',
    configId: '',
  })

  const [smsProviderConfiguration, setSmsProviderConfiguration] = useState({
    value: '',
    key: '',
    configId: '',
  })

  const { timeOutSession } = useSession()

  const [
    getAllGaJob,
    {
      loading: getAllGaJobLoading,
      refetch: getAllGaJobRefetch,
      fetchMore: getAllGaJobFetchMore,
      error: getGAListError,
    },
  ] = useLazyQuery(GET_ALL_GA_JOB, { fetchPolicy: 'no-cache' })

  const { data: configurationByTypeData, refetch: getSMSProviderConfigRefetch } = useQuery(
    GET_CONFIGURATION_BY_TYPE,
    {
      fetchPolicy: 'no-cache',
      variables: {
        type: 'SMS_SETTING',
      },
    },
  )

  const [getConfigurationByType] = useLazyQuery(GET_CONFIGURATION_BY_TYPE)

  const [cancelJobById, { error: errorCancelJobById }] = useMutation(CANCEL_JOB_BY_ID)
  const [cancelRelatedJobsByPGNumber, { error: errorCancelRelatedJobsByPGNumber }] = useMutation(
    CANCEL_RELATED_JOBS_BY_PG_NUMBER,
  )
  const [triggerJobById, { error: errorTriggerJobById }] = useMutation(TRIGGER_JOB_BY_ID)
  const [updateConfigurationById] = useMutation(UPDATE_CONFIGURATION_BY_ID)

  const pendingJobStatus = ['PENDING', 'START_STREAM']
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false)

  const handleGetServiceConfiguration = (newConfiguration?: any) => {
    if (newConfiguration) {
      setServiceConfiguration(newConfiguration)
    } else {
      getConfigurationByType({ variables: { type: 'SERVICE_SETTING' } }).then((response) => {
        if (!response.data?.getConfigurationByType) return

        if (response.data?.getConfigurationByType?.length > 0) {
          const config = response?.data?.getConfigurationByType.find(
            (item: { key: string }) => item.key === 'IS_STOP_JOB',
          )
          if (config) setServiceConfiguration(config)
        }
      })
    }
  }

  useEffect(() => {
    if (configurationByTypeData && configurationByTypeData.getConfigurationByType.length > 0) {
      const config = configurationByTypeData?.getConfigurationByType?.find(
        (item: { key: string }) => item.key === 'SMS_PROVIDER',
      )
      setSmsProviderConfiguration({
        value: config?.value || 'vonage',
        configId: config?.configId || '',
        key: 'SMS_PROVIDER',
      })
    } else {
      setSmsProviderConfiguration({
        value: 'vonage',
        configId: '',
        key: 'SMS_PROVIDER',
      })
    }
  }, [configurationByTypeData])

  const handleGetGaJobData = async (searchObject: Variables) => {
    const response = await getAllGaJob({
      variables: searchObject,
      fetchPolicy: 'network-only',
    })

    if (!response.data.getAllGaJob) return

    const responseData = response.data.getAllGaJob

    if (responseData.items && responseData.pageInfo) {
      setListGAJobData(responseData.items)
      setPageInfoGAJob(responseData.pageInfo)
    }
  }

  useEffect(() => {
    handleGetServiceConfiguration()
  }, [])

  useEffect(() => {
    if (
      searchObject &&
      JSON.stringify(searchObject) !== JSON.stringify(prevSearchObjectRef.current)
    ) {
      handleGetGaJobData(searchObject)
    }
    prevSearchObjectRef.current = searchObject
  }, [searchObject])

  const handleSearchEmailAndPhone = (value: string) => {
    setSearchObject((state) => {
      return { ...state, searchValue: value.trim(), limit: DEFAULT_PAGINATION.LIMIT, page: 1 }
    })
  }
  const handleSearchApplicationNumber = (value: string) => {
    setSearchObject((state) => {
      return { ...state, applicationNumber: value.trim(), limit: DEFAULT_PAGINATION.LIMIT, page: 1 }
    })
  }

  const onHandleClickShowAction = (item: any) => {
    if (showAction.jobId == item.jobId) {
      return
    }
    setShowAction({
      jobId: item.jobId,
      isShowAction: true,
    })
    setCurrentJobItemSelected({ ...item })
  }

  const onHandleClickCancelSingleJobAction = () => {
    setIsOpenModalCancelSingleJob(true)
  }

  const onHandleClickCancelRelatedJobAction = () => {
    setIsOpenModalCancelRelatedJobs(true)
  }

  const onHandleConfirmCancelSingleJobAction = async () => {
    if (currentJobItemSelected && pendingJobStatus.includes(currentJobItemSelected.status)) {
      const dataRes = await cancelJobById({
        variables: {
          jobId: currentJobItemSelected?.jobId,
        },
      })
      if (dataRes) {
        notify(MESSAGES.SUCCESS.S_GENERAL_SUCCESS, STATUS.SUCCESS)
        setIsRefetchList(true)
      }
      handleCloseConfirmInfoDialog()
    } else {
      handleCloseConfirmInfoDialog()
    }
  }

  const onHandleConfirmCancelRelatedJobsAction = async () => {
    if (currentJobItemSelected && pendingJobStatus.includes(currentJobItemSelected.status)) {
      const dataRes = await cancelRelatedJobsByPGNumber({
        variables: {
          applicationNumber: currentJobItemSelected?.applicationNumber,
        },
      })
      if (dataRes) {
        notify(MESSAGES.SUCCESS.S_GENERAL_SUCCESS, STATUS.SUCCESS)
        setIsRefetchList(true)
      }
      handleCloseConfirmInfoDialog()
    } else {
      handleCloseConfirmInfoDialog()
    }
  }

  const onHandleClickTriggerJobAction = () => {
    setIsOpenModalTriggerJob(true)
  }
  const onHandleClickViewDetailJobAction = () => {
    setIsOpenModalViewDetailJob(true)
  }
  const onHandleConfirmTriggerJobAction = async () => {
    if (currentJobItemSelected && pendingJobStatus.includes(currentJobItemSelected.status)) {
      notify('Requested', STATUS.INFO)
      const dataRes = await triggerJobById({
        variables: {
          jobId: currentJobItemSelected?.jobId,
        },
      })
      if (dataRes) {
        notify(MESSAGES.SUCCESS.S_GENERAL_SUCCESS, STATUS.SUCCESS)
      }
      setIsRefetchList(true)
      handleCloseConfirmInfoDialog()
    } else {
      handleCloseConfirmInfoDialog()
    }
  }

  const handleCloseConfirmInfoDialog = () => {
    setIsOpenModalViewDetailJob(false)
    setIsOpenModalCancelSingleJob(false)
    setIsOpenModalCancelRelatedJobs(false)
    setIsOpenModalTriggerJob(false)
    setIsRefetchList(true)
  }

  useEffect(() => {
    const errorMessages = [
      errorCancelJobById?.message,
      errorTriggerJobById?.message,
      errorCancelRelatedJobsByPGNumber?.message,
    ]

    const errorMessage = errorMessages.find((message) => message)
    if (errorMessage) {
      notify(errorMessage, STATUS.ERROR)
    }
  }, [errorCancelJobById, errorTriggerJobById, errorCancelRelatedJobsByPGNumber])

  const startDateChange = (value: Date) => {
    setMinDateFilter(value)
    const dateFrom = value ? moment(value).format('YYYY-MM-DD') : ''
    setSearchObject((state) => {
      return { ...state, dateFrom, limit: DEFAULT_PAGINATION.LIMIT, page: DEFAULT_PAGINATION.PAGE }
    })
  }
  const endDateChange = (value: Date) => {
    setMaxDateFilter(value)
    const dateTo = value ? moment(value).format('YYYY-MM-DD') : ''
    setSearchObject((state) => {
      return { ...state, dateTo, limit: DEFAULT_PAGINATION.LIMIT, page: DEFAULT_PAGINATION.PAGE }
    })
  }
  useEffect(() => {
    if (isRefetchList) {
      handleRefetch()
      setIsRefetchList(false)
    }
  }, [isRefetchList])

  useEffect(() => {
    const handleClickOutSide = (e: any) => {
      if (menuRef && !menuRef.current?.contains(e.target)) {
        setShowAction({ jobId: null, isShowAction: false })
      }
    }
    document.addEventListener('mousedown', handleClickOutSide)
    return () => {
      document.removeEventListener('mousedown', handleClickOutSide)
    }
  }, [showAction])

  useEffect(() => {
    const handleClickOutSideFilter = (e: any) => {
      if (
        subjectFilterRef &&
        !subjectFilterRef.current?.contains(e.target) &&
        subjectCheckboxRef &&
        !subjectCheckboxRef.current?.contains(e.target) &&
        e.target.id !== 'filter-ref'
      ) {
        setIsOpenFilter(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutSideFilter)
    return () => {
      document.removeEventListener('mousedown', handleClickOutSideFilter)
    }
  }, [isOpenFilter])

  useEffect(() => {
    const clientHeight = document.querySelector('#cus-scrollbar')?.clientHeight
    if (document.querySelector('#cus-scrollbar')?.clientHeight && clientHeight) {
      setIsTableGaScroll(clientHeight >= 588)
    }
  }, [document.querySelector('#cus-scrollbar')?.clientHeight, listGAJobData])

  useEffect(() => {
    if (getGAListError?.graphQLErrors[0]?.extensions?.code === CODE_TIMEOUT) {
      timeOutSession()
    }
  }, [getGAListError])

  const handleButtonStartOrStop = () => {
    updateConfigurationById({
      variables: {
        configurationId: serviceConfiguration.configId,
        data: {
          value: (!(serviceConfiguration.value.toLowerCase() === 'true')).toString(),
        },
      },
    }).then((response) => {
      handleGetServiceConfiguration(response.data.updateConfigurationById)
      if (response.data.updateConfigurationById.value.toLowerCase() === 'true') {
        //  Restart (isStop === true)
        notify(MESSAGES.SUCCESS.S_RESTART_SENDING_EMAIL_JOB, STATUS.SUCCESS)
      } else {
        notify(MESSAGES.SUCCESS.S_STOP_SENDING_EMAIL_JOB, STATUS.SUCCESS)
      }
    })
  }

  const onHandleToggleChangeStatus = async () => {
    if (smsProviderConfiguration.configId) {
      updateConfigurationById({
        variables: {
          configurationId: smsProviderConfiguration.configId,
          data: {
            value: smsProviderConfiguration.value === 'ozeki' ? 'vonage' : 'ozeki',
          },
        },
      }).then(() => {
        getSMSProviderConfigRefetch()
      })
    } else {
      notify('SMS Provider not setting, use VONAGE as default provider', STATUS.ERROR)
    }
  }

  const handleButtonDownload = async () => {
    try {
      setDisableDownloadBtn(true)
      const response = await axiosInstance.post('/export/job', searchObject, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data])

      // Create a temporary URL for the Blob
      const url = URL.createObjectURL(blob)

      // Create a download link and initiate the file download
      const downloadLink = document.createElement('a')
      downloadLink.href = url
      downloadLink.download = 'jobData.csv'
      downloadLink.click()
    } catch (error: Error | any) {
      if (isAxiosError(error)) {
        notify(error.message, STATUS.ERROR)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    } finally {
      setDisableDownloadBtn(false)
    }
  }

  const getStatusValue = (val: any) => {
    if (val.name === 'ALL') {
      setSearchObject((state) => {
        return {
          ...state,
          status: null,
          limit: DEFAULT_PAGINATION.LIMIT,
          page: DEFAULT_PAGINATION.PAGE,
        }
      })
    } else {
      setSearchObject((state) => {
        return {
          ...state,
          status: val.name,
          limit: DEFAULT_PAGINATION.LIMIT,
          page: DEFAULT_PAGINATION.PAGE,
        }
      })
    }
  }

  const handleFetchMore = async () => {
    try {
      const variables = { ...searchObject, page: pageInfoGAJob.currentPage + 1 }
      const response = await getAllGaJobFetchMore({ variables })

      if (!response.data.getAllGaJob) return

      const responseData = response.data.getAllGaJob

      if (responseData.items) {
        const data = listGAJobData.concat(responseData.items)
        setListGAJobData(data)
      }
    } catch (error) {
      notify(MESSAGES.ERROR.E_TRY_AGAIN, STATUS.ERROR)
    }
  }

  const handleRefetch = async () => {
    const response = await getAllGaJobRefetch(searchObject)

    const responseData = response.data.getAllGaJob

    if (responseData.items && responseData.pageInfo) {
      setListGAJobData(responseData.items)
      setPageInfoGAJob(responseData.pageInfo)
    }
  }

  return (
    <div>
      <div className="flex justify-between mb-3">
        <p className="pt-2 text-headline5A text-neutral-1">System Job Data</p>
        <div className="flex items-end space-x-4">
          <TotalNumberInTable number={pageInfoGAJob.totalItems} />
          <ButtonBase
            className="disabled:bg-primary-shade3"
            bgHover="Download detail email job csv"
            onClick={handleButtonDownload}
            disabled={disableDownloadBtn}
          >
            Download CSV
          </ButtonBase>
          <div>
            <div className="flex">
              <span
                className={
                  'flex min-w-[60px] w-full font-montserrat font-medium text-base text-primary-50'
                }
              >
                {smsProviderConfiguration.value === 'ozeki' ? 'Ozeki' : 'Vonage'}
                <a
                  data-tip
                  id="sms-provider-tool-tip"
                  data-for="sms-provider-tool-tip"
                  className="pl-1 flex"
                >
                  <img src={IconInformation} alt="Icon-Information" className="w-[18px]" />
                </a>
                <ReactTooltip id="sms-provider-tool-tip" type="info" effect="solid">
                  <span>
                    {smsProviderConfiguration.value === 'ozeki'
                      ? 'Using Ozeki as default provider'
                      : 'Using Vonage as default provider'}
                  </span>
                </ReactTooltip>
              </span>
            </div>
            <div>
              <CheckBoxBase
                value={smsProviderConfiguration.value === 'ozeki'}
                handleToggle={onHandleToggleChangeStatus}
              />
            </div>
          </div>
          <div>
            <div className="flex">
              <span
                className={
                  'flex min-w-[60px] w-full font-montserrat font-medium text-base text-primary-50'
                }
              >
                {serviceConfiguration.value.toLowerCase() === 'true' ? 'Stop' : 'Start'}
                <a
                  data-tip
                  id="job-service-tool-tip"
                  data-for="job-service-tool-tip"
                  className="pl-1 flex"
                >
                  <img src={IconInformation} alt="Icon-Information" className="w-[18px]" />
                </a>
                <ReactTooltip id="job-service-tool-tip" type="info" effect="solid">
                  <span>Enable or disable automated run Job</span>
                </ReactTooltip>
              </span>
            </div>
            <div>
              <CheckBoxBase
                value={serviceConfiguration.value.toLowerCase() !== 'true'}
                handleToggle={handleButtonStartOrStop}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full h-[112px] mb-5 grid grid-cols-3 gap-2">
        <DateFilterPicker setCallBackDateChange={startDateChange} maxDate={maxDateFilter} />
        <DateFilterPicker setCallBackDateChange={endDateChange} minDate={minDateFilter} />
        <DropdownBase
          options={[{ id: 'ALL', name: 'ALL' }].concat(EMAIL_JOB_STATUS)}
          handleOptions={getStatusValue}
          initialValue={'ALL'}
        />
        <div
          className={classNames('rounded-xl border-[2px] w-full', {
            'border-neutral-3': isFocusSearchEmailText,
            'border-neutral-5': !isFocusSearchEmailText,
          })}
        >
          <SearchInput
            classInput="border-0 w-full"
            setIsFocus={setIsFocusEmailText}
            handleSearch={handleSearchEmailAndPhone}
            placehoderText="Search box email or text no"
            isHandleSearch={false}
          />
        </div>
        <div
          className={classNames('rounded-xl border-[2px]  w-full', {
            'border-neutral-3': isFocusApplicationNumber,
            'border-neutral-5': !isFocusApplicationNumber,
          })}
        >
          <SearchInput
            classInput="border-0 w-full"
            setIsFocus={setIsFocusApplicationNumber}
            handleSearch={handleSearchApplicationNumber}
            placehoderText="Search application number"
            isHandleSearch={false}
          />
        </div>
      </div>
      <div className="z-10 w-full border-2 border-neutral-6 bg-neutral-8 rounded-2xl">
        <ul
          className={`flex bg-primary-shade4 px-4 py-6 justify-between rounded-t-[14px] ${
            isTableGaScroll ? 'pr-20' : ''
          }`}
        >
          {tableHeaderJobData.map((item, idx) => (
            <li className={`${item.headerClassName} relative flex`} key={idx}>
              <span className={`font-montserrat font-bold text-base text-neutral-2`}>
                {item.label}
              </span>
            </li>
          ))}
        </ul>
        {getAllGaJobLoading && <Loading className="relative py-6" height={30} width={30} />}
        {!listGAJobData?.length && !getAllGaJobLoading && (
          <p className="py-6 text-center text-body1 text-neutral-4">No data available.</p>
        )}

        {Boolean(listGAJobData && listGAJobData?.length > 0 && !getAllGaJobLoading) && (
          <InfiniteScroll
            dataLength={listGAJobData?.length ?? 0}
            next={handleFetchMore}
            hasMore={pageInfoGAJob.hasNextPage}
            height={'max-content'}
            style={{ maxHeight: 500 }}
            loader={''}
            endMessage={''}
            className={'small-scrollbar'}
          >
            {listGAJobData.map((item: IJobItem, idx: number) => (
              <ul
                className="flex px-4 py-3 mb-3 text-base font-medium font-montserrat text-neutral-3 hover:bg-neutral-7 hover:text-neutral-1"
                key={idx}
              >
                <li className={tableHeaderJobData[0].bodyClassName}>
                  <p>{item.jobId}</p>
                </li>
                <li className={tableHeaderJobData[1].bodyClassName}>
                  <p>{item.jobName}</p>
                </li>
                <li className={tableHeaderJobData[2].bodyClassName}>
                  <p>{item.stageDate && <Moment format="MM/DD/YYYY">{item.stageDate}</Moment>}</p>
                </li>
                <li className={tableHeaderJobData[3].bodyClassName}>
                  <p>{item?.stageCompleted}</p>
                </li>
                <li
                  className={`${tableHeaderJobData[4].bodyClassName} `}
                  // className={`${tableHeaderJobData[4].bodyClassName} ${
                  //   Object.keys(JOB_STATUS_COLOR).includes(item.status)
                  //     ? JOB_STATUS_COLOR[item.status as keyof typeof JOB_STATUS_COLOR]
                  //     : ''
                  // }`}
                >
                  <p>{item.status}</p>
                </li>
                <li className={tableHeaderJobData[5].bodyClassName}>
                  <p>{item.applicationNumber}</p>
                </li>
                <li className={tableHeaderJobData[6].bodyClassName}>
                  <p>{item.email}</p>
                </li>
                <li className={tableHeaderJobData[7].bodyClassName}>
                  <p>{item.phoneNumber}</p>
                </li>
                <button
                  className={tableHeaderJobData[8].bodyClassName}
                  onClick={() => onHandleClickShowAction(item)}
                >
                  <div className="relative">
                    <img src={IconDot} alt="Icon-Dot" className="" />
                    {showAction?.jobId === item.jobId && showAction.isShowAction && (
                      <div
                        className={`absolute right-[2px] h-auto p-3 border shadow-2xl w-[250px] border-neutral-7 bg-neutral-8 rounded-xl z-10`}
                        ref={menuRef}
                      >
                        <SingleRowActionBase
                          handleAction={onHandleClickViewDetailJobAction}
                          icon={IconInformation}
                          action="ViewDetail"
                          txt="View Detail"
                        />
                        <SingleRowActionBase
                          handleAction={onHandleClickTriggerJobAction}
                          icon={IconApprove}
                          action="TriggerJob"
                          txt="Trigger Job"
                          block={!pendingJobStatus.includes(item.status)}
                        />
                        <hr className="my-1 border-t-neutral-7" />
                        <SingleRowActionBase
                          handleAction={onHandleClickCancelSingleJobAction}
                          action="CancelSingleJob"
                          block={!pendingJobStatus.includes(item.status)}
                          txt="Cancel Single Job"
                        />
                        <hr className="my-1 border-t-neutral-7" />
                        <SingleRowActionBase
                          handleAction={onHandleClickCancelRelatedJobAction}
                          action="CancelRelatedJob"
                          block={!pendingJobStatus.includes(item.status)}
                          txt="Cancel Related Jobs"
                        />
                      </div>
                    )}
                  </div>
                </button>
              </ul>
            ))}
          </InfiniteScroll>
        )}
        {isOpenModalViewDetailJob && (
          <DetailItemDialog
            key="detailItemDialog"
            modalIsOpen={true}
            handleCloseDialog={handleCloseConfirmInfoDialog}
            jobData={currentJobItemSelected}
          />
        )}

        <DialogBasic
          modalIsOpen={isOpenModalCancelSingleJob}
          title="Cancel Job"
          confirmation="Are you sure you want to cancel this job?"
          action="Confirm"
          cancel="No"
          handleCloseDialog={handleCloseConfirmInfoDialog}
          handleAction={onHandleConfirmCancelSingleJobAction}
        />

        <DialogBasic
          modalIsOpen={isOpenModalCancelRelatedJobs}
          title="Cancel Job"
          confirmation={`Are you sure you want to all related jobs of PG ${currentJobItemSelected?.applicationNumber} ? `}
          action="Confirm"
          cancel="No"
          handleCloseDialog={handleCloseConfirmInfoDialog}
          handleAction={onHandleConfirmCancelRelatedJobsAction}
        />
        <DialogBasic
          modalIsOpen={isOpenModalTriggerJob}
          title="Trigger Job"
          confirmation="Are you sure you want to trigger this job?"
          action="Trigger"
          handleCloseDialog={handleCloseConfirmInfoDialog}
          handleAction={onHandleConfirmTriggerJobAction}
        />
      </div>
    </div>
  )
}

export default memo(JobTable)
